import * as Sentry from "@sentry/browser";

export const initSentry = () => {
  // Only initialize if DSN is available
  const dsn = import.meta.env.VITE_SENTRY_DSN;

  if (!dsn) {
    console.warn("Sentry DSN not found in environment variables");
    return;
  }

  try {
    Sentry.init({
      dsn,
      sendDefaultPii: true,
      integrations: [Sentry.browserTracingIntegration()],
      tracesSampleRate: 1.0,
      tracePropagationTargets: [
        /^https:\/\/api\.leapfrog\.caden\.ai/,
        /^https:\/\/app\.caden\.ngrok\.app/,
        /^https:\/\/app\.leapfrog\.cloud/,
      ],
    });
  } catch (error) {
    console.error("Failed to initialize Sentry:", error);
  }
};

export const showFeedbackDialog = () => {
  try {
    const eventId = Sentry.captureMessage("User feedback requested");

    return eventId;
  } catch (error) {
    console.error("Failed to generate feedback event ID:", error);
    return null;
  }
};
